import React from 'react';
import DevicesOutlinedIcon from '@mui/icons-material/DevicesOutlined';
import EditCalendarOutlinedIcon from '@mui/icons-material/EditCalendarOutlined';
import GravityLogo from './GravityLogo';

const NAV = [
  { section: 'Operations', items: [
    { id: 'dashboard',     label: 'Dashboard',         icon: '▣' },
    { id: 'products',      label: 'Products',          icon: '✦' },
    { id: 'product-types', label: 'Product Types',     icon: '☆' },
    // Calendar Settings is no longer in the menu (user's request); schedules are
    // managed on Schedule Calendar. Its page is still routed in App.js.
    { id: 'schedule-calendar', label: 'Schedule Calendar', icon: <EditCalendarOutlinedIcon fontSize="small" /> },
    { id: 'bonus-prizes',  label: 'Bonus Prizes',      icon: '★' },
    { id: 'transactions',  label: 'Transactions',      icon: '▤' },
  ]},
  { section: 'Sales', items: [
    { id: 'coupon', label: 'Coupon', icon: '✿' },
  ]},
  { section: 'Administration', items: [
    { id: 'users',  label: 'Users',              icon: '☺', adminOnly: true },
    { id: 'stores', label: 'Stores',             icon: '⌂', adminOnly: true },
    { id: 'devices', label: 'Devices',           icon: <DevicesOutlinedIcon fontSize="small" />, adminOnly: true },
    { id: 'rights', label: 'User & Store Rights', icon: '☑', adminOnly: true },
  ]},
];

export default function Sidebar({ activePage, onNavigate, collapsed, onToggleCollapse, open, roleId }) {
  const isAdmin = roleId === 'ADMIN';

  const navGroups = NAV
    .map(group => ({
      ...group,
      items: group.items.filter(item => !item.adminOnly || isAdmin),
    }))
    .filter(group => group.items.length > 0);

  return (
    <div className={`sidebar${collapsed ? ' sidebar-collapsed' : ''}${open ? ' sidebar-open' : ''}`}>
      <div className="sidebar-logo">
        <div className="sidebar-logo-left">
          <div className="sidebar-logo-detail">
            <div className="sidebar-logo-text">Good Find</div>
            <div className="sidebar-logo-subtitle">Instant Rewards</div>
          </div>
        </div>
        <button className="sidebar-toggle-btn" onClick={onToggleCollapse} aria-label={collapsed ? 'Open menu' : 'Close menu'}>
          {collapsed ? '›' : '‹'}
        </button>
      </div>
      <div className="sidebar-nav">
        {navGroups.map(group => (
          <div key={group.section}>
            {!collapsed && <div className="sidebar-section">{group.section}</div>}
            {collapsed && <div className="sidebar-divider" />}
            {group.items.map(item => (
              <div
                key={item.id}
                className={`sidebar-item${activePage === item.id ? ' active' : ''}`}
                onClick={() => onNavigate(item.id)}
                title={collapsed ? item.label : ''}>
                <span className="sidebar-item-icon">{item.icon}</span>
                {!collapsed && <span className="sidebar-item-label">{item.label}</span>}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
